module.exports = __webpack_public_path__ + "img/remaining.6ef81ea4.svg";